import { redirect } from '@tanstack/react-router'

import { publicIssuesSearchSchema } from '@/screens/ipo/PublicIssuesScreen.loader'

/**
 * The `/issues` loader: Public Issues moved under Market (`/market/issues`),
 * and an old link, bookmark or sidebar row keeps its `?type=&status=&page=`.
 * Always throws, so a replace keeps the dead URL out of the back stack.
 */
export function loadIssuesRedirect({ location }: { location: { search: unknown } }): never {
  // eslint-disable-next-line @typescript-eslint/only-throw-error
  throw redirect({
    to: '/market/issues',
    search: publicIssuesSearchSchema.parse(location.search),
    replace: true,
  })
}
